import {
  InMemoryHeader,
  InMemoryString,
  InMemoryDate
} from "pbas-vue-components";
import { translate2 } from "../trans2";

const ExtendedBenefitsHeaders = [
  new InMemoryHeader({
    title: "Id",
    type: new InMemoryString("Id"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false
  }),
  new InMemoryHeader({
    title: "globals.coverage",
    type: new InMemoryString(
      "TerminatedExtendedCoverageIdentityIds"
    ),
    sortable: false,
    visible: false,
    searchable: false,
    version: 2,
  }),
  new InMemoryHeader({
    title: "globals.coverage",
    type: new InMemoryString(
      "TerminatedExtendedCoverageIdentities[]/Current/Translations[]/Name",
      {
        getString: (item) => {
          console.log(item);
          if (item === null || item === undefined || item.TerminatedExtendedCoverageIdentities === null || item.TerminatedExtendedCoverageIdentities === undefined) {
            return "";
          }
          return item.TerminatedExtendedCoverageIdentities.map((o) =>
          {console.log(o);
            return translate2(o.Current, "Name")}
          ).join(", ");
        },
        getHtml: (item, type) => {
          return (
            "<div style='word-wrap: break-word; white-space: pre-wrap; min-width: 200px'>" +
            type.getString(item, type) +
            "</div>"
          );
        },
      }
    ),
    sortable: false,
    visible: true,
    searchable: true,
    version: 1,
  }),
  new InMemoryHeader({
    title: "components.memberview.extension_termination_date",
    type: new InMemoryDate("ExtensionTerminationDate"),
    sortable: true,
    visible: true,
    searchable: true
  }),
];
export default ExtendedBenefitsHeaders;